import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LogoIcon = props => (
  <SvgIcon {...props} viewBox="0 0 275 103">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Sift-Logo-all-white_large" fillRule="nonzero" fill="#dedede">
        <circle id="Oval-1-Copy-33" cx="12" cy="49" r="12" />
        <circle id="Oval-1-Copy-35" cx="46" cy="49" r="12" />
        <circle id="Oval-1-Copy-37" cx="80" cy="49" r="12" />
        <circle id="Oval-1-Copy-39" cx="46" cy="87" r="12" />
        <path
          d="M168.9,54.9 C168.9,42.4 160.9,32.8 143.9,32.8 C129,32.8 117.9,39.7 117.9,55.4 C117.9,69.1 127.6,73.4 137.6,74.7 C145.9,75.8 153.5,75.9 153.5,81.8 C153.5,85.2 150.2,88.9 143.8,88.9 C136.1,88.9 133.5,86.1 133.2,81.2 L117,81.2 C117,94.6 126.8,103 143.1,103 C157.9,103 169.7,96.4 169.7,81.2 C169.7,68.8 160.5,63.3 151.3,62.2 C142.1,61.1 134.2,62.2 134.2,54.5 C134.2,49.7 137.9,47.2 144.1,47.2 C149.2,47.2 153.3,49.6 153.3,54.9 L168.9,54.9 Z M195.4,35.5 L179.2,35.5 L179.2,102.7 L195.4,102.7 L195.4,35.5 Z M178.2,17.9 C178.2,30 196.5,29.8 196.5,17.9 C196.6,5.8 178.2,5.7 178.2,17.9 L178.2,17.9 Z M240.6,1.4 C217.2,-1.6 204.6,11.1 204.6,28.6 L204.6,102.6 L222.2,102.6 L222.2,48.1 L236.8,48.1 L238.5,48.1 L238.5,32.4 L222.2,32.4 L222.2,28.8 C222.2,20.2 228.8,15.1 240.6,17 L240.6,1.4 Z M245.9,76 C245.9,97.5 253.8,104.9 275,102.5 L275,87.8 C263.8,89.2 262.6,83.7 262.6,75.8 L262.6,45.2 L274.8,45.2 L274.8,29.5 L262.6,29.5 L262.6,15.7 L245.9,17.5 L245.9,76 L245.9,76 Z"
          id="sift-copy-11"
        />
      </g>
    </g>
  </SvgIcon>
);

export default LogoIcon;
